/* Styles */
import './toggleSwitch3.css';

const ToggleSwitch3 = ({ onChange, checked }) => {
  const toggleClass = 'toggle-active';

  const onToggle = () => {
    onChange(!checked); // Cambia el estado externamente
  }

  return (
    <div
      className={`toggle-switch3 ${checked ? 'no' : 'si'}`}
      onClick={onToggle}
    >
      <div className={`toggle-inner ${checked ? null : toggleClass}`}></div>
    </div>
  );
}

export default ToggleSwitch3;